module.exports = __webpack_public_path__ + "img/電気回路_2_7_5.8fe43c67.png";